export const otherEvents = {
    COOKIE_POLICY_ACCEPT: 'cookie-policy-accept'
};
